import React, { useEffect, useState } from 'react';
import { Select, Row, Col, Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getHubspotDeals, createPricingDeal } from '../../services/Apis';
import LogoutPopUp from '../../components/LogoutPopUp';


const { Option } = Select;
const { Text } = Typography;
interface hubspotDeals {
  deal_id: number;
  deal_name: string;
  deal_owner_name: string;
  can_create_pricing: boolean;
}

const CreatePricing: React.FC = () => {
  // Options for the dropdowns
  const [hubspotDeals, setHubspotDeals] = useState<hubspotDeals[]>([]);
  const [createDealError, setCreateDealError] = useState<string | null>(null);
  const [selectedDealId, setSelectedDealId] = useState<number | null>(null);
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);

  useEffect(() => {
    const getDeals = async () => {
      const getDealsResponse = await getHubspotDeals();
      if (getDealsResponse.error_status === 401) {
        setTokenExpired(true);
      } else {
        if (getDealsResponse.error) {
          console.error('Error Response Data:', getDealsResponse.error);
          console.error('Error Response Status:', getDealsResponse.error_status);
          setCreateDealError(getDealsResponse.error);
        } else {
          setHubspotDeals(getDealsResponse);
        }
      }
    };
    getDeals();
  }, []);

  const createDealPricing = async () => {
    if (!selectedDealId) {
      setCreateDealError('Please select a HubSpot Deal');
      return;
    }
    const createPricing = await createPricingDeal(selectedDealId);
    if (createPricing.error_status === 401) {
      setTokenExpired(true);
    } else {
      if (createPricing.error) {
        console.error('Error Response Data:', createPricing.error);
        console.error('Error Response Status:', createPricing.error_status);
        setCreateDealError(createPricing.error);
      } else {
        navigate(`/edit-pricing-details?dealId=${selectedDealId}&versionName=${encodeURIComponent(createPricing.version_name)}`);
      }
    }
  }



  const navigate = useNavigate(); // React Router hook for navigation

  const handleNavigate = () => {
    navigate('/edit-pricing-details?dealId=23031725466&versionName=Initial%20Version%20-%20October%2014,%202024%2008:38%20PM');  // Navigate to /create-pricing page
  };

  return tokenExpired ? (<LogoutPopUp openPopup={tokenExpired} />) : (
    <Row gutter={16}>
      {createDealError && <Text type="danger">{createDealError}</Text>}
      {/* Hubspot Deals */}
      <Col span={24}>
        <div style={{ marginBottom: '0px' }}>
          <Text><strong>Select a HubSpot Deal</strong></Text><br></br>
        </div>
        <div style={{ marginBottom: '10px' }}>
          <Text type="secondary">Select a HubSpot deal that does not yet have any pricing created. If the deal already has a pricing version, head to the Pricing Tool homepage, where you can edit or create new pricing versions.</Text>
        </div>
        <div style={{ marginBottom: '2px' }}>
          <Text type="secondary">Search by Client, Deal Name, HubSpot ID, or Deal Owner</Text>
        </div>
      </Col>
      <Col span={16}>
        <Select
          showSearch
          placeholder="HubSpot Deal"
          style={{ width: '100%' }}
          filterOption={(input, option: any) =>
            option?.children?.toLowerCase().includes(input.toLowerCase())
          }
          onSelect={(value) => setSelectedDealId(value)}
          // disabled={JSON.parse(localStorage.getItem('user_details') as string).features.includes('FE_CREATE_PRICING') ? false : true}
        >
          {hubspotDeals
          .filter(option => option.can_create_pricing)
          .map((option, index) => (
            <Option key={index} value={option.deal_id}>
              {option.deal_name + ' | ' + option.deal_id + ' | ' + option.deal_owner_name}
            </Option>
          ))}
        </Select>
      </Col>
      {/* Create New Pricing */}
      <Col span={8}>
        <Button disabled={selectedDealId ? false : true} style={{ width: '100%'}} className='custom-button' onClick={createDealPricing}>
          Create New Pricing
        </Button>
      </Col>
    </Row>
  );
};

export default CreatePricing;
